import { useQuery } from "react-query";
import { request } from "utils/axios-utils";

export const useCustomQuery = (
  queryKey,
  requestObj = { url: "", method: "get", data: {} },
  queryObj = {}
) => {
  return useQuery(
    queryKey,
    () => request({ ...requestObj, avoidCancelling: true }),
    {
      ...queryObj,
    }
  );
};
